<template>
  <NuxtLink
    :to="to"
    class="group flex items-center gap-x-2 text-[22px] font-medium text-black transition-colors hover:text-black/50"
    @click="uiStore.showMenu = false"
  >
    <slot />
    <SvgGlyphArrowRight
      class="h-5 w-5 flex-none opacity-0 transition-opacity group-hover:opacity-100"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
interface Props {
  to: string
}

defineProps<Props>()

const uiStore = useUIStore()
</script>
